import React from 'react'
import Styles from "./BirthdayScreen.module.css"
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import DateUtilities from '../../componentes/DateUtilities'
import Confetti from './Confetti'
import PageLoader from '../../componentes/pageLoader/pagelLoader'
import ComponentLoader from '../../componentes/componentLoader/componentLoader'
import {getCompanyCollection} from '../../firebase'

class BirthdayScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dataLoaded:false,
            loaderVisible:Styles.visible,
            pageVisible:Styles.hidden,
            profilePic:Styles.hidden,
            profilePicLoader:Styles.visible,
            list: [],
            nombre: '',
            image: '',
            i: 1,
            nextScreen: 'ActivitiesScreen',
            sendNextPage: () => {
                this.props.nextPageProp(this.state.nextScreen);
           },
        }
        this.cakeUrl=''
        this.ballonsUrl=''
        this.ballonsImgLoaded=false
        this.cakeImgLoaded=false
    }
    componentDidMount() {
        console.log('birthday')
        this.getData()
    }
    getImgsUrls=async()=>{
        const ref=firebase.storage().ref()
        const promise1= ref.child('images/site-pics/cake2-min.png').getDownloadURL()
        const promise2= ref.child('images/site-pics/ball4.png').getDownloadURL()
        const promise3= ref.child('images/site-pics/avatar1.png').getDownloadURL()
        const promise4= ref.child('images/site-pics/avatar2.png').getDownloadURL()
        this.cakeUrl=await promise1
        this.ballonsUrl=await promise2
        this.femaleUrl=await promise3
        this.maleUrl=await promise4
    }
    getData=async()=>{
        await this.getImgsUrls()
        try{
            const dayAndMonth=DateUtilities.getDayAndMonthString(DateUtilities.today())
            const snapShot=await (await getCompanyCollection('Empleados')).where('Cumple', '==', dayAndMonth).get()
            const list=[]
            for(let i=0; i<snapShot.docs.length; i++){
                if(!snapShot.docs[i].exists) break
                const employee=snapShot.docs[i].data()
                let img=''
                try{
                    img=await firebase.storage().ref().child(`images/profile-pics/${employee.foto}.jpg`).getDownloadURL()
                }
                catch{
                    img=employee.genero==='masculino' ? this.maleUrl: this.femaleUrl
                }
                list.push({
                    name:employee.Nombre,
                    image:img,
                })
            }
            console.log(list)
            if(list.length===0)  {
                console.log('no birthdays')
                return  this.state.sendNextPage()
            } //window.location.replace("https://saul-ramos-frambuesa.web.app/tele")
            this.setState({
                list:list,
                nombre:list[0].name,
                image:list[0].image,
                dataLoaded:true,
            })
        }
        catch(e){
            console.log(e.message)
            if(e.message==='Failed to get document because the client is offline.'){
                return this.getData()
            }
        }
    }
    setTimer=()=>{
        this.interval = setInterval(() => {
            if (this.state.i < this.state.list.length) {
                this.setState({
                    nombre: this.state.list[this.state.i].name,
                    image: this.state.list[this.state.i].image,
                    i: this.state.i + 1,
                    profilePic:Styles.hidden,
                    profilePicLoader:Styles.visible, 
                })
            }  else if(this.state.i >= this.state.list.length){
                this.state.sendNextPage()
                //window.location.replace("https://saul-ramos-frambuesa.web.app/tele")
            }
        }, 8000)
    }
    componentDidUpdate(prevProps, prevState){
        if(prevState.list!==this.state.list){
            this.isPageLoaded()
        }
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    handleLoad=(name)=>{
        if(!this.state.dataLoaded) return null
        console.log(name)
        this[name]=true
        this.isPageLoaded()
    }
    handleProfilePicLoad=()=>{
        this.setState({
            profilePicLoader:Styles.hidden,
            profilePic:Styles.visible,
        })
    }
    isPageLoaded=()=>{
        if(this.ballonsImgLoaded && this.cakeImgLoaded && this.state.dataLoaded){
            this.setState({
                pageVisible:Styles.visible,
                loaderVisible:Styles.hidden,
            })
            this.setTimer()
        }
    }
    render() {
        return (
            <>
            <PageLoader className={this.state.loaderVisible} />
            <div className={`${Styles.mainconteiner} ${Styles.col} ${this.state.pageVisible}`}>
                <Confetti width="100%" height="100%"></Confetti>
                <div className={`${Styles.griditem} ${Styles.container} ${Styles.alingdown}`}>
                    <img src={this.state.dataLoaded? this.ballonsUrl :''} alt="ballons" className={`${Styles.ballons}`} onLoad={()=>{this.handleLoad('ballonsImgLoaded')}} onError={()=>{this.handleLoad('ballonsImgLoaded')}} />
                </div>
                <div className={`${Styles.griditem } ${Styles.container} ${Styles.rows}`}>

                    <div className={`${Styles.griditem} ${Styles.container} ${Styles.cols} ${Styles.grow4}`}>
                        <div className={`${Styles.griditem} ${Styles.container} ${Styles.centercontent} ${Styles.centeritems} ${Styles.justifycenter}`}>
                            <div className={`${Styles.frame} ${Styles.container} ${Styles.centercontent} ${Styles.rows}`}>
                                <div className={`${Styles.griditem} ${Styles.profilePicBox} ${Styles.grow3}` }>
                                    <ComponentLoader className={this.state.profilePicLoader}/>
                                    <img src={this.state.dataLoaded? this.state.image :''} alt="img" className={`${Styles.avatar} ${this.state.profilePic}`} onLoad={this.handleProfilePicLoad} onError={this.handleProfilePicLoad} />
                                </div>
                                <div className={`${Styles.griditem} ${Styles.container} ${Styles.justifycenter} ${Styles.alingcenter}`}>
                                    <span className={`${Styles.name}`}>{this.state.nombre}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={`${Styles.griditem} ${Styles.container} ${Styles.reward} ${Styles.justifycenter} ${Styles.alingdown}`}>
                        <span className={`${Styles.color1} ${Styles.fontsize1}`}>F</span>
                        <span className={`${Styles.color3} ${Styles.fontsize1}`}>E</span>
                        <span className={`${Styles.color5} ${Styles.fontsize1}`}>L</span>
                        <span className={`${Styles.color2} ${Styles.fontsize1}`}>I</span>
                        <span className={`${Styles.color4} ${Styles.fontsize1}`}>Z</span>
                    </div>

                    <div className={`${Styles.griditem} ${Styles.container} ${Styles.reward} ${Styles.ustifycenter} ${Styles.alingup}`}>

                        <span className={`${Styles.color5} ${Styles.fontsize2}`}>C</span>
                        <span className={`${Styles.color2} ${Styles.fontsize2}`}>U</span>
                        <span className={`${Styles.color1} ${Styles.fontsize2}`}>M</span>
                        <span className={`${Styles.color3} ${Styles.fontsize2}`}>P</span>
                        <span className={`${Styles.color6} ${Styles.fontsize2}`}>L</span>
                        <span className={`${Styles.color4} ${Styles.fontsize2}`}>E</span>
                        <span className={`${Styles.color2} ${Styles.fontsize2}`}>A</span>
                        <span className={`${Styles.color1} ${Styles.fontsize2}`}>Ñ</span>
                        <span className={`${Styles.color3} ${Styles.fontsize2}`}>O</span>
                        <span className={`${Styles.color6} ${Styles.fontsize2}`}>S</span>
                    </div>

                </div>
                <div className={`${Styles.griditem} ${Styles.container} ${Styles.alingdown} ${Styles.justifyright}`}>
                    <img src={ this.state.dataLoaded? this.cakeUrl :''} alt="cake" className={`${Styles.cake}`} onLoad={()=>{this.handleLoad('cakeImgLoaded')}} onError={()=>{this.handleLoad('cakeImgLoaded')}}/>
                </div>
            </div>
            </>
        )
    }
}

export default BirthdayScreen;

